import React, { createContext, useContext } from 'react';

/**
 * Native loads its font files asynchronously; web has them from the stylesheet.
 * Everything that renders text reads this so the app is usable before the
 * custom faces arrive rather than flashing empty.
 */
const FontsReadyContext = createContext(true);

export function FontsProvider({
  ready,
  children,
}: {
  ready: boolean;
  children: React.ReactNode;
}) {
  return <FontsReadyContext.Provider value={ready}>{children}</FontsReadyContext.Provider>;
}

export function useFontsReady(): boolean {
  return useContext(FontsReadyContext);
}
